import React from "react";

const Admin = () => {
  return (
    <div className="home-page">
      <h2>WIP</h2>
    </div>
  );
};

export default Admin;
